import { render, staticRenderFns } from "./ClinicalMonitoring.vue?vue&type=template&id=165e66c4&"
import script from "./ClinicalMonitoring.vue?vue&type=script&lang=js&"
export * from "./ClinicalMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports